module.exports = __webpack_public_path__ + "static/media/30.c827a2b3.JPG";